import DashboardTotalBalance from '@widgets/dashboard/DashboardTotalBalance';
import DashboardActiveCards from '@widgets/dashboard/DashboardActiveCards';
import DashboardDecline from '@widgets/dashboard/DashboardDecline';
import {
  CreateCardBtn,
  TopUpBalanceBtn,
  WithdrawBalanceBtn,
} from '@widgets/buttons';
import { ThemeButton } from '@shared/ui/buttons';
import { usePlansDialog } from '@utils/dialogs-hooks';
import DashboardSpentChart from '@widgets/dashboard/DashboardSpentChart';
import DashboardDeclineRate from '@widgets/dashboard/DashboardDeclineRate';
import { useTranslation } from 'react-i18next';
import PrivateBins from '@widgets/dashboard/PrivateBins';
import DashboardCards from '@widgets/dashboard/DashboardCards';
import { useSelector } from 'react-redux';
import { roles } from '@shared/static/roles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '@utils/libs/theme';

export default function DashboardVerified() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { openPlansDialog } = usePlansDialog();
  const isMember = user.group_role === roles.TEAM_MEMBER;

  return (
    <section className="dashboard main-section">
      <div className="block-pd-y block-pd-x">
        <p className="title-h2m">{t('Dashboard')}</p>
      </div>
      <div className={`dashboard__grid ${isMember ? 'is-member' : ''}`}>
        {!isMember && (
          <div className="dashboard__block dashboard__block-cards">
            <div className="block-pd-x">
              <DashboardTotalBalance />
              <div className="btns-toolbar">
                <TopUpBalanceBtn />
                {!user.group_role && <WithdrawBalanceBtn />}
              </div>
            </div>
            <DashboardCards />
          </div>
        )}
        <div className="dashboard__grid-2">
          <div className="dashboard__block border-right block-pd-x">
            <DashboardActiveCards />
            <div className="btns-toolbar">
              <CreateCardBtn />
              {!isMember && (
                <ThemeButton
                  appearance="secondary"
                  startIcon="arrow-up"
                  onClick={openPlansDialog}
                  block={false}
                >
                  {t('increase_limits')}
                </ThemeButton>
              )}
            </div>
          </div>
          {/* <div className="dashboard__block block-pd-x">
            <DashboardDecline />
          </div> */}
          <div className="dashboard__block start-2  block-pd-y">
            <div className="block-pd-x">
              {/* <DashboardDeclineRate /> */}
              <DashboardSpentChart />
            </div>
            <div className={`offer ${!isMobile ? 'block-pd-x' : ''}`}>
              <PrivateBins />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
